import React from 'react';
import ConfirmDialog from '../../shared/ConfirmDialog';
import { useTranslation } from 'react-i18next';

export default function DeleteDialog({
  title = 'Confirm deletion',
  content = 'Are you sure you want to delete this item? This action cannot be undone.',
  open,
  onClose,
  onConfirm
}) {
  const { t } = useTranslation();

  return (
    <ConfirmDialog
      title={t(title)}
      content={typeof content == 'string' ? t(content) : content}
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
    />
  );
}
